import { useStaticQuery, graphql } from 'gatsby'

export function useGeneral() {
  const {
    allPagesJson: {
      nodes: [general],
    },
  } = useStaticQuery(graphql`
    query General {
      allPagesJson(filter: { id: { eq: "general" } }) {
        nodes {
          previous
          restart
          averagePrice
          recalculate
        }
      }
    }
  `)

  return general
}
